__turbopack_context__.v({
  "tableContainer": "IndicatorTable-timeline-module__y9lPoa__tableContainer",
});
